import { createAsyncThunk } from '@reduxjs/toolkit';
import FeedService from '../../../api/services/FeedService';
import { getSeenTrendingIds } from '../../../utils/trendingSeen';

export const getFeed = createAsyncThunk('feed/getFeed', async ({ limit, cursor } = {}) => {
  return await FeedService.getFeed(limit, cursor);
});

export const getTrendingFeed = createAsyncThunk(
  'feed/getTrendingFeed',
  async ({ limit, cursor, seed, phase, excludedFeedItems } = {}) => {
    const mergedExcludedFeedItems = Array.from(new Set([...getSeenTrendingIds(), ...(excludedFeedItems || [])]));
    return await FeedService.getTrendingFeed({
      limit,
      cursor,
      seed,
      phase,
      excludedFeedItems: mergedExcludedFeedItems,
    });
  },
);

export const likeFeedItem = createAsyncThunk('feed/likeFeedItem', async ({ feedItemId }) => {
  await FeedService.likeFeedItem(feedItemId);
  return { feedItemId };
});

export const unlikeFeedItem = createAsyncThunk('feed/unlikeFeedItem', async ({ feedItemId }) => {
  await FeedService.unlikeFeedItem(feedItemId);
  return { feedItemId };
});

export const shareFeedItem = createAsyncThunk('feed/shareFeedItem', async ({ feedItemId, platform }) => {
  await FeedService.shareFeedItem(feedItemId, platform);
  return { feedItemId, platform };
});

export const createFeedComment = createAsyncThunk('feed/createFeedComment', async ({ feedItemId, text }) => {
  const response = await FeedService.createFeedComment(feedItemId, text);
  return { ...response, feedItemId };
});

export const getFeedComments = createAsyncThunk('feed/getFeedComments', async ({ feedItemId, limit, cursor }) => {
  const response = await FeedService.getFeedComments(feedItemId, limit, cursor);
  return { ...response, feedItemId };
});

export const createFeedReply = createAsyncThunk('feed/createFeedReply', async ({ feedCommentId, feedItemId, text }) => {
  const response = await FeedService.createFeedReply(feedCommentId, text);
  return { ...response, feedCommentId, feedItemId };
});

export const getFeedReplies = createAsyncThunk('feed/getFeedReplies', async ({ feedCommentId, limit, cursor }) => {
  const response = await FeedService.getFeedReplies(feedCommentId, limit, cursor);
  return { ...response, feedCommentId };
});

export const likeFeedComment = createAsyncThunk('feed/likeFeedComment', async ({ feedCommentId }) => {
  await FeedService.likeFeedComment(feedCommentId);
  return { feedCommentId };
});

export const unlikeFeedComment = createAsyncThunk('feed/unlikeFeedComment', async ({ feedCommentId }) => {
  await FeedService.unlikeFeedComment(feedCommentId);
  return { feedCommentId };
});

export const deleteFeedComment = createAsyncThunk(
  'feed/deleteFeedComment',
  async ({ feedCommentId, feedItemId, parentCommentId }) => {
    await FeedService.deleteFeedComment(feedCommentId);
    return { feedCommentId, feedItemId, parentCommentId };
  },
);
